import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { Search } from "lucide-react";
import { useI18n } from "@/i18n";
import { PageHero } from "@/pages/PageHero";
import { CategoryCard } from "@/components/catalog/CatalogCards";
import { QuoteWhatsApp } from "@/components/catalog/QuoteWhatsApp";
import { useSeo } from "@/lib/useSeo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CatalogIndex() {
  const { t, lang } = useI18n();
  const [categories, setCategories] = useState([]);
  const [search, setSearch] = useState("");
  useEffect(() => { axios.get(`${API}/catalog/categories?lang=${lang}`).then((response) => setCategories(response.data)); }, [lang]);
  const visible = useMemo(() => categories.filter((category) => category.name.toLowerCase().includes(search.toLowerCase())), [categories, search]);
  useSeo({ title: t.catalog.seo.title, description: t.catalog.seo.description, path: "/equipements" });
  return (
    <div data-testid="catalog-page">
      <PageHero eyebrow="MB300 · by NELVIS FRANCE" title={t.catalog.title} text={t.catalog.intro} image={categories[0]?.image_url} />
      <section className="container-x pb-28">
        <div className="flex flex-col gap-5 border-y border-white/10 py-7 sm:flex-row sm:items-center sm:justify-between">
          <label className="relative w-full sm:max-w-md"><Search className="absolute left-4 top-3.5 h-4 w-4 text-[var(--steel-dim)]" /><span className="sr-only">{t.catalog.search}</span><input value={search} onChange={(event) => setSearch(event.target.value)} placeholder={t.catalog.search} data-testid="catalog-search" className="w-full border border-white/15 bg-[#0B1530] py-3 pl-11 pr-4 text-white outline-none focus:border-[var(--gold)]" /></label>
          <QuoteWhatsApp itemType="generic" itemId="catalog" title={t.catalog.title} testIdPrefix="catalog" />
        </div>
        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {visible.map((category, index) => <CategoryCard key={category.id} category={category} index={index} />)}
        </div>
      </section>
    </div>
  );
}